import React from 'react'
import ProductRestaurantCommentContainer from '../../../../Components/Comments/ProductRestaurantCommentContainer/ProductRestaurantCommentContainer'
import Layout from '../../Layout'

const ProductRestaurantComment = () => {
  return (
    <Layout>
        <ProductRestaurantCommentContainer/> 
    </Layout>
  )
}

export default ProductRestaurantComment